export interface AccessRight {
    id: string;
    action: string;
}

export interface NavItem {
    displayName: string;
    disabled?: boolean;
    iconName: string;
    route?: string;
    location?: string;
    access?: AccessRight;
    children?: NavItem[];
}

export const navItems: NavItem[] = [
    {
        displayName: 'Customers',
        iconName: 'people_outline',
        route: 'customer',
        children: [
            {
                access: { id: 'customer', action: 'view' },
                displayName: 'Customer Search',
                iconName: 'search',
                route: 'customer/usersearch',
            },

            {
                access: { id: 'customer', action: 'view' },
                displayName: 'Endpoint Search',
                iconName: 'phone',
                route: 'customer/endpointsearch',
            },
        ],
    },
    {
        displayName: 'Risk',
        iconName: 'face',
        route: 'risk',
        children: [
            {
                displayName: 'Rules',
                iconName: 'rule',
                route: 'risk/decisions',
                access: { id: 'risk-rule', action: 'view' },
            },
            {
                displayName: 'BlockList',
                iconName: 'stop',
                route: 'risk/blocklist',
                access: { id: 'risk-blocklist', action: 'view' },
            },
        ],
    },
    {
        displayName: 'Marketplace',
        iconName: 'money',
        children: [
            {
                displayName: 'Subscriptions',
                iconName: 'schedule',
                access: { id: 'marketplace-order', action: 'view' },
                route: 'marketplace/subscriptions',
            },
            {
                displayName: 'Orders',
                iconName: 'receipt_long',
                access: { id: 'marketplace-order', action: 'view' },
                route: 'marketplace/orders',
            },
            {
                displayName: 'ExternalOrders',
                iconName: 'receipt_long',
                access: { id: 'marketplace-external-order', action: 'view' },
                route: 'marketplace/externalorders',
            },
            {
                displayName: 'Products',
                iconName: 'inventory',
                access: { id: 'marketplace-product', action: 'view' },
                route: 'marketplace/products',
            },
            {
                displayName: 'Promotions',
                iconName: 'upgrades',
                access: { id: 'marketplace-promotion', action: 'view' },
                route: 'marketplace/promotions',
            },
            {
                displayName: 'PriceLists',
                iconName: 'list_alt',
                access: { id: 'marketplace-pricelist', action: 'view' },
                route: 'marketplace/pricelists',
            },
        ],
    },
    {
        displayName: 'Configuration',
        iconName: 'article',
        access: { id: 'configuration', action: 'view' },

        children: [
            {
                displayName: 'Configurations',
                iconName: 'article',
                route: 'configuration/configurations',
            },
        ],
    },
    {
        displayName: 'Payment',
        iconName: 'payment',
        children: [
            {
                displayName: 'Payments',
                iconName: 'payments',
                route: 'payment/payments',
                access: { id: 'payment', action: 'view' },
            },
            {
                displayName: 'Vault',
                iconName: 'account_balance',
                route: 'payment/vault',
                access: { id: 'vault', action: 'view' },
            },
            {
                displayName: 'Categories',
                iconName: 'category',
                route: 'payment/groups',
                access: { id: 'payment', action: 'view' },
            },
        ],
    },
    {
        displayName: 'Calling',
        iconName: 'phone',
        children: [
            {
                displayName: 'Numbers',
                iconName: 'tag',
                route: 'calling/numbers',
                access: { id: 'calling-number', action: 'view' },
            },
            {
                displayName: 'Areas',
                iconName: 'south_america',
                route: 'calling/areas',
                access: { id: 'calling-area', action: 'view' },
            },
            {
                displayName: 'Dids',
                iconName: 'phone_callback',
                route: 'calling/dids',
                access: { id: 'calling-did', action: 'view' },
            },
        ],
    },
    {
        displayName: 'Users',
        iconName: 'admin_panel_settings_two_tone',
        children: [
            {
                displayName: 'Users',
                iconName: 'supervisor_account_outlined',
                route: 'users/users',
                access: { id: 'user', action: 'view' },
            },
            {
                displayName: 'Roles',
                iconName: 'manage_accounts_two_tone',
                route: 'users/roles',
                access: { id: 'user-role', action: 'view' },
            },
        ],
    },
    {
        displayName: 'Subscription',
        iconName: 'subscriptions',
        children: [
            {
                displayName: 'Subscriptions',
                iconName: 'payments',
                route: 'subscription/subscriptions',
                access: { id: 'subscription', action: 'view' },
            },
        ],
    },
];
